var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { default as SSVG } from './SearchS';
import { default as XsSVG } from './SearchXs';
import { forwardRef } from 'react';
const SearchSVG = forwardRef((_a, ref) => {
    var { size = 24 } = _a, props = __rest(_a, ["size"]);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return Number(size) >= 20 ? _jsx(SSVG, Object.assign({ ref: ref, size: size }, props)) : _jsx(XsSVG, Object.assign({ ref: ref, size: size }, props));
});
export default SearchSVG;
